<template>
<div class="container">
    <PauseModal
        v-if="modal_pause"
        @restart="
        modal_pause = !modal_pause;
        reset=true;
        play=true;
        playMusic = !playMusic;
      " @closeModal="
        modal_pause = !modal_pause;
        reset=false;
        finish_play();
      " @resume="
        modal_pause = !modal_pause;
        reset=false;
        play=true;
        playMusic = !playMusic;
      " />

    <Congratulations
        v-if="congrats_modal"
        :gallery="gallery"
        @restart="congrats_modal = !congrats_modal;"
        @backToMenu="$emit('backToMenu');"
        @saveGame="$emit('onSavingGame', phrases); congrats_modal = !congrats_modal;"
     />

    <div id="melody-summary-container" class="container-2">
        <div class="score-container-melody-summary">
            <PhraseDisplaySummary :color="white" :phrase="beats" :levels="curve" />
        </div>
        <div id="score-container-melody-summary-canvas" class="score-container-melody-summary-canvas">
            <canvas :id="'canvas-score'" class="canvas"></canvas>
        </div>
        <div id="melody-summary-playing-bar" class="playing-line" :class="{'active': active}"></div>
    </div>
    <MidiPlayer :midi="midi" :playMidi="playMusic" @finishedPlaying="finish_play" :reset="reset" @currentPosition="viewPosition"></MidiPlayer>

    <div class="buttons-summary">
        <div class="play-mel tamanhoicon" >
            <img @click="play_pause" :src="require('@/assets/buttons/newbuttons/melody/pause.svg')" v-if="play" />
            <img @click="play_pause" :src="require('@/assets/buttons/newbuttons/melody/play.svg')" v-else />
        </div>
        <div class="complete-mel tamanhoicon" >
            <img @click="congratsPopup" :src="require('@/assets/buttons/newbuttons/melody/submit.svg')" />
        </div>
    </div>
</div>
</template>

<script>
import MidiPlayer from "../General/MidiPlayer.vue";
import PhraseDisplaySummary from "@/components/MelodyGame/PhraseDisplaySummary.vue";
import PauseModal from "@/components/MelodyGame/PauseModal.vue";
import Congratulations from "@/components/MelodyGame/Congratulations.vue";

export default {
    name: "SummaryScore",
    emits: ['backToMenu', 'restart', 'onFinish', 'onSavingGame'],
    components: {
        MidiPlayer,
        PhraseDisplaySummary,
        PauseModal,
        Congratulations,
    },
    created() {
        window.addEventListener("resize", this.resize);
    },
    mounted() {
        this.resize();
    },
    unmounted() {
        console.log('SUMMARTY UNMOUNRED')
    },
    data() {
        return {
            play: false,
            playMusic: false,
            midi: "",
            reset: false,
            active: false,

            currentScroll: 0,
            muted: false,

            modal_pause: false,
            congrats_modal: false,
            alert_modal: false,

            curve: [],
            beats: [],
            coord: []
        };
    },
    props: {
        phrases: Object,
        gallery: Boolean,
    },
    methods: {
        congratsPopup (){
            this.congrats_modal=true;
            this.play=false;
            this.playMusic = false;
        },
        resize() {
            this.calculateCurves();
            this.drawPhrase();
        },
        calculateCurves() {
            let beats = Object.values(this.phrases.music);
            this.curve = beats.map((e) => {
                if (e[0][3] != 0) return e[0][3];
                let poss = e.map((e1) => {
                    return e1[3]
                });
                let non_zero = poss.find((value) => value !== 0);
                if (non_zero !== undefined) return non_zero;
                return 2;
            });
            this.beats = beats;
            this.coord = this.calculateCurveFromPoints(this.curve);
        },
        calculateCurveFromPoints(points) {
            let width = window.innerWidth * ((points.length + 1) / 8.0);
            let height = window.innerHeight;

            let div_w = width / (points.length + 1);
            let div_h = height / 8;

            let line_3 = [];

            line_3.push({
                x: 0,
                y: height / 2.0,
            });

            let last_x = 0;
            for (let j = 0; j < points.length; j++) {
                last_x += div_w;

                let num = points[j];
                let y = num * div_h;
                if (num == 1) {
                    y -= div_h / 6.0;
                }
                if (num == 3) {
                    y += div_h / 6.0;
                }

                line_3.push({
                    x: last_x,
                    y: y,
                });
            }

            line_3.push({
                x: last_x + div_w,
                y: height / 2.0,
            });

            let maxArray = Math.max.apply(null, line_3.map(function (el) {
                return el.y + 2.5 * div_h
            }));
            let minArray = Math.min.apply(null, line_3.map(function (el) {
                return el.y - 0.5 * div_h
            }));
            if (maxArray > window.innerHeight) {
                line_3 = line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y - (window.innerHeight - maxArray) - 5
                    }
                });
            } else if (minArray < window.innerHeight / 9.0) {
                line_3 = line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + (window.innerHeight / 9.0)
                    }
                });
            }

            return {
               /* line_1: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y - 0.5 * div_h,
                    };
                }), */
                line_2: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + 0.25 * div_h,
                    };
                }),
                line_3: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + div_h,
                    };
                }),
                line_4: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + 1.75 * div_h,
                    };
                }),
               /* line_5: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + 2.5 * div_h,
                    };
                }),  */
            };
        },
        drawPhrase() {
            let canvas = document.getElementById("canvas-score");
            let cv_rect = canvas.getBoundingClientRect();

            let ctx = canvas.getContext("2d");

            cv_rect.width = this.coord['line_2'][this.coord['line_2'].length - 1].x;
            ctx.canvas.width = this.coord['line_2'][this.coord['line_2'].length - 1].x;
            canvas.width = this.coord['line_2'][this.coord['line_2'].length - 1].x;
            canvas.height = cv_rect.height;

            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

            for (let line in this.coord) {
                this.draw_curve_aux(ctx, this.coord[line], 0.9, '#FFFFFF', 2);
            }
            setTimeout(() => {
                this.adjust_positions('line_3');
            })
        },
        adjust_positions(line) {
            let coord = this.coord[line].slice(1, this.coord[line].length - 1);

            let maxY = Math.max.apply(null, this.coord['line_4'].slice(1, this.coord['line_4'].length - 1).map(function (el) {
                return el.y
            }));

            // Beats
            for (let j = 0; j < coord.length; j++) {

                let cd = coord[j];

                let div = document.getElementById("Beat-" + j.toString());
                let width = 10;

                if (div != null) {
                    div.style.position = "absolute";
                    div.style.left = cd.x - (div.clientWidth / 4.0) + 'px';
                    div.style.top = cd.y - (div.clientHeight / 2.0) + 'px';
                    width = div.offsetWidth;
                }

                let lycs = document.getElementById("Beat-Lyc-" + j.toString());

                if (lycs != null) {
                    lycs.style.position = "absolute";
                    lycs.style.left = cd.x - (div.clientWidth / 4.0) + 'px';
                    lycs.style.top = maxY + 30 + 'px';
                    lycs.style.width = width + 'px';
                }
            }

        },
        play_pause() {
            if (this.play) {
                this.popup_pausa();
            } else {
                this.play_music();
            }
        },
        popup_pausa() {
            this.modal_pause = !this.modal_pause;
            this.play = false;
            this.playMusic = !this.playMusic;
        },
        finish_play() {
            this.play = false;
            let container = document.getElementById("melody-summary-container");
            container.scrollTo(0, 0);
            this.active = false;
        },
        viewPosition(pos) {

            let canvas = document.getElementById("canvas-score");
            let container = document.getElementById("melody-summary-container");
            let temp_scroll = 0;

            if (pos !== 'Not Playing') {
                this.active = true;

                let div = document.getElementById('melody-summary-playing-bar');
                let canvas_width = canvas.width;

                if (div != null) {

                    let posX = pos * canvas_width;
                    div.style.position = "absolute";
                    div.style.left = posX + 'px';

                    let max_scroll = Math.ceil(canvas_width / window.innerWidth);

                    for (let sX = 0; sX < max_scroll; sX++) {
                        if (posX > sX * window.innerWidth && posX < (sX + 1) * window.innerWidth) {
                            temp_scroll = sX * window.innerWidth;
                            break;
                        }
                    }
                }

            } else {
                this.active = false;
                temp_scroll = 0;
            }

            if (this.currentScroll !== temp_scroll) {
                container.scrollTo(temp_scroll, 0);
                this.currentScroll = temp_scroll;
            }
        },
        play_music() {

            let phrase = this.phrases['music'];
            let notes = [];
            for (let b in Object.keys(phrase)) {
                let beat = Object.keys(phrase)[b];
                for (let note in phrase[beat]) {
                    let dur = phrase[beat][note][2];
                    if (dur == 1) {
                        dur = this.phrases["whole_duration"];
                    }
                    notes.push([phrase[beat][note][1], dur]);
                }
            }

            this.midi = {
                'tracks': {
                    '0': {
                        'instrument': this.$data.instruments.percussion.Cowbells.name,
                        'is_percussion': false,
                        'notes': notes,
                        'is_muted': this.muted,
                        'loudness': 0.85
                    }
                },
                'whole_duration': this.phrases['whole_duration'],
            }
            this.play = true;
            this.playMusic = !this.playMusic;
        },
    }
};
</script>

<style>
.container {
    width: 100%;
    height: 100%;

    position: absolute;
}

.complete {
    position: absolute;
    right: 1rem;
    bottom: 1rem;
}

.edit {
    position: absolute;
    left: 5rem;
    top: 1rem;
}

.play-mel {
    margin-right: 4%;
}

.record-sing {
    position: absolute;
    bottom: 1em;
    left: 52%;
}
.buttons-summary{
    width: 100%;
    display: flex;
    position: absolute;
    bottom: 7%;
    justify-content: center;
}

.instrument-mute-sing {
    position: absolute;
    bottom: 0.6em;
    left: 43%;

    background: chartreuse;
    opacity: 8.0;
    border-radius: 50%;

    display: flex;
    justify-content: space-around;

    width: 1.5em !important;
    height: 1.5em;
    margin-left: 2em;

    z-index: 2;
}

.instrument-mute-sing.muted {
    background: red;
}

.instrument-mute-sing>img {
    width: 0.75em !important;
}

.score-container {
    display: flex;
    align-self: center;
    flex-wrap: nowrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;

    width: 100%;

    padding-top: 4%;
    height: 90%;
}

.lateral {
    width: 5%;
}

.rightbutton {
    margin-right: 3%;
}

.leftbutton {
    margin-left: 3%;
}

.score {
    width: 80%;
    height: 100%;

    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;

    /* display: inline_3-grid;
  grid-template-columns: 12.5% 12.5% 12.5% 12.5% 12.5% 12.5% 12.5% 12.5%;
  grid-template-rows: 33% 33% 33%; */
}

.beat-score {
    display: flex;
    align-self: center;
    justify-content: center;
}

.note {
    margin: 0 -1.2rem;
}

.beat-level-1 {
    margin-top: -45%;
}

.beat-level-2 {
    margin-top: -4em;
}

.beat-level-3 {
    margin-top: 35%;
}

.canvas {
    position: absolute;
    top: 0;

    width: 100%;
    height: 100%;

    z-index: -1;
}

.choose {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 1em;
    height: 150%;
    padding: 1em;
}

@media only screen and (max-width: 686px) {
    .lateral {
        width: 2.7rem;
        height: 2.7rem;
    }

    .rightbutton {
        margin-right: 3%;
    }

    .edit {
        left: 4.5rem;
    }

    .note {
        margin: 0 -1rem;
        width: 4rem;
    }

    .choose {
        padding: 0.8rem;
    }

    .beat-level-2 {
        margin-top: -1em;
    }

    .beat-level-3 {
        margin-top: 37%;
    }

    .hidden {
        height: 5em;
        width: 2em;
    }

    .score {
        width: 78%;
    }

}

@media only screen and (min-width: 1024px) {

    .lateral {
        width: 4.5rem;
        height: 4.5rem;
    }

    .edit {
        left: 6.5rem;
    }

    .note {
        margin: 0 -1.5rem;
        width: 7rem;
    }

    .score {
        width: 79%;
    }
}

@media only screen and (min-width: 1300px) {

    .lateral {
        width: 6rem;
        height: 6rem;
    }

    .edit {
        left: 7.5rem;
    }

    .note {
        margin: 0 -1.5rem;
        width: 9rem;
    }

    .hidden {
        height: 11.3em;
        width: 6em;
    }

}
</style>
